<div [class.other-message]="messageType === CHAT_MESSAGE_TYPE.BAKERY"
     [class.my-message]="messageType === CHAT_MESSAGE_TYPE.CUSTOMER">
  <div class="pinned-info-container" *ngIf="orderRequest.description">
    <div class="text-muted-warm font-xs lh-1"
         [translate]="'titles.productDescription'">
      Product description
    </div>

    <div class="mt-1 font-md description-lh order-description">
      {{ orderRequest.description }}
    </div>
  </div>

  <div class="pinned-info-container"
       *ngIf="orderRequest.images?.length">
    <ng-container *ngFor="let img of orderRequest.images; let ind=index">
      <div class="d-flex justify-content-between"
           [class.mt-1]="ind">
        <div class="info-item-img me-3 pointer">
          <img [src]="img.image.id | multiImage: 'smallUrl' : true : ''"
               (click)="showImage(img.image.originalUrl)">
        </div>

        <div class="info-item-desc font-md w-100">
          {{ img.description }}
        </div>
      </div>
    </ng-container>
  </div>

  <div class="pinned-info-container" *ngIf="orderRequest.extendedDescription">
    <div class="text-muted-warm font-xs lh-1"
         [translate]="'titles.howManyGuestsServings'">
      How many guests/servings?
    </div>

    <div class="mt-1 font-md description-lh">
      {{ orderRequest.extendedDescription }}
    </div>
  </div>

  <ng-container *ngIf="showDeliveryDetails">
    <div class="pinned-info-container" *ngIf="isToDoor">
      <div class="text-muted-warm font-xs line-height-1"
           [translate]="'common.delivery.deliveryAddress'">Delivery address
      </div>

      <div class="mt-1 font-md">
        {{ deliveryOrder.deliveryAddress }}<br>
        {{ deliveryOrder.deliveryPostNumber }} {{ deliveryOrder.deliveryCity }}
      </div>
    </div>

    <div class="pinned-info-container" *ngIf="isPickup">
      <div class="text-muted-warm font-xs line-height-1"
           [translate]="'common.delivery.pickUpLocation'">Outlet
      </div>

      <div class="mt-1 font-md">
        {{ deliveryOrder.outlet?.name || deliveryOrder.deliveryAddress}}
      </div>
    </div>

    <div class="pinned-info-container">
      <div class="font-xs text-muted-warm lh-1">
        <span *ngIf="isToDoor"
              [translate]="'common.delivery.deliveryTime'"></span>

        <span *ngIf="isPickup"
              [translate]="'common.delivery.pickUpTime'"></span>
      </div>

      <ui-order-delivery-time
        class="font-md"
        [deliveryDate]="deliveryOrder.deliveryDate"
        [deliveryTime]="deliveryOrder.deliveryTime"
      ></ui-order-delivery-time>
    </div>
  </ng-container>

  <div class="text-end font-xxs font-mute">
    {{requestCreatedDate | i18nDate : 'DD MMM YY HH:mm'}}
  </div>
</div>
